let deferredPrompt = null;
let initialized = false;
const listeners = new Set();

function isStandaloneDisplayMode() {
  if (typeof window === "undefined") return false;
  const mediaStandalone = Boolean(window.matchMedia?.("(display-mode: standalone)")?.matches);
  const iosStandalone = Boolean(window.navigator?.standalone);
  return mediaStandalone || iosStandalone;
}

function emit() {
  const state = getInstallPromptState();
  for (const cb of listeners) {
    try {
      cb(state);
    } catch {}
  }
}

function onBeforeInstallPrompt(event) {
  event.preventDefault();
  deferredPrompt = event;
  emit();
}

function onAppInstalled() {
  deferredPrompt = null;
  emit();
}

export function initInstallPromptListeners() {
  if (initialized || typeof window === "undefined") return;
  initialized = true;
  window.addEventListener("beforeinstallprompt", onBeforeInstallPrompt);
  window.addEventListener("appinstalled", onAppInstalled);
}

export function getInstallPromptState() {
  return {
    canPrompt: Boolean(deferredPrompt),
    isInstalled: isStandaloneDisplayMode(),
  };
}

export function subscribeInstallPromptState(callback) {
  if (typeof callback !== "function") return () => {};
  listeners.add(callback);
  callback(getInstallPromptState());
  return () => listeners.delete(callback);
}

export async function promptInstall() {
  if (!deferredPrompt) return { outcome: "unavailable" };
  try {
    deferredPrompt.prompt();
    const choiceResult = await deferredPrompt.userChoice;
    const outcome = String(choiceResult?.outcome || "dismissed");
    if (outcome === "accepted") deferredPrompt = null;
    emit();
    return { outcome };
  } catch {
    return { outcome: "error" };
  }
}

